/*
 * Page Name
 */

(function ($) {

    _heightline({
        itemClsName: '.jobs_block01_item03_item',
        itemPerRow: 2,
    });
    
    jQuery( ".jobs_block_content ._btn_more" ).on( "click", function(e) {
        e.preventDefault();
        var _prev_des = jQuery(this).prev('.jobs_block_content_box');

        jQuery(this).toggleClass('_hide');

        if(_prev_des.hasClass("_show")) {
            jQuery(this).find("a").text("閉じる");
        } else {
            jQuery(this).find("a").text("もっと見る");
        }
        _prev_des.toggleClass('_show');
    });

})(jQuery);